import { render, staticRenderFns } from "./ResponsiveIframe.vue?vue&type=template&id=491748ee&scoped=true&"
import script from "./ResponsiveIframe.vue?vue&type=script&lang=js&"
export * from "./ResponsiveIframe.vue?vue&type=script&lang=js&"
import style0 from "./ResponsiveIframe.vue?vue&type=style&index=0&id=491748ee&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "491748ee",
  null
  
)

export default component.exports